import React from "react";
import { Tag } from "@planzone/dto";
import { TagIcon } from "@common/tagList/tagIcon";
import { VisibilityWatcher } from "@common/visibilityWatcher";
import { TagForm } from "@common/tagForm";
import { Props } from "./types";
import styles from "./styles.scss";

function ButtonTagForm(props: Props) {
  return (
    <VisibilityWatcher>
      {(isVisible, show, hide) => (
        <div className={styles.iconBox}>
          {show && (
            <div onClick={isVisible ? hide : show}>
              <TagIcon className={styles.icon} />
            </div>
          )}
          {isVisible && (
            <div className={styles.form}>
              <TagForm
                filters={props.tags}
                type={"projects"}
                submit={(tag: Tag) => {
                  props.assignTag(tag);
                  hide();
                }}
              />
            </div>
          )}
        </div>
      )}
    </VisibilityWatcher>
  );
}

export { ButtonTagForm };
